export default __webpack_public_path__ + "img/7ef7d10242139dfc82d36eb90ce99a08.svg";